import { getSintegradaServerApi } from "@/services/api";
import { Department } from "@/@types/sintegrada/Department";

export type DepartmentParams = {
	uf: string;
	ibgeCode: string;
	cnes?: string;
};

export async function getDepartments({ uf, ibgeCode, ...params }: DepartmentParams) {
	const url = `/Department/departments`;

	const { data } = await getSintegradaServerApi().get<Department[]>(url, { ibgeCode, ...params });

	return data || [];
}
